import type { Request } from "./_type";

import { useDelete } from "~/common/hooks";

/** useChatSessions */
export const useDeleteSession = (external_user: string) => {
  /** URL */
  const url = `/users/${external_user}`;

  /** return */
  return useDelete<Request>(url);
};
